import { render, staticRenderFns } from "./HealthScore.vue?vue&type=template&id=110ea9c4&"
import script from "./HealthScore.vue?vue&type=script&lang=js&"
export * from "./HealthScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports